
import { RevList } from '@ds/components/List'
import { RevListItem } from '@ds/components/ListItem'
import { IconChevronRight } from '@ds/icons/IconChevronRight'

import { MODAL_NAMES } from '@config/constants'
import { productFrequentlyAskedQuestions } from '@http/endpoints'

import AsyncModal from '../AsyncModal'

import translations from './FaqModal.translations'

export default {
  components: {
    AsyncModal,
    RevList,
    RevListItem,
    IconChevronRight,
  },
  props: {
    listingId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      questions: [],
    }
  },
  computed: {
    modalName: () => MODAL_NAMES.PRODUCT.FAQ,
    translations: () => translations,

    productId() {
      return this.$route.params.uuid
    },
  },
  methods: {
    async fetchFrequentlyAskedQuestions() {
      const { payload } = await this.$store.dispatch('http/request', {
        request: productFrequentlyAskedQuestions,
        pathParams: { id: this.productId, listingId: this.listingId },
      })

      this.questions = payload.questions
    },
  },
}
